import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { UpdateEnumeratorProfilePayloadInterface } from "./dto";
import { db } from "../../../firebase/firebase";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";

export const updateEnumeratorProfile = async ({
  id,
  enumerator,
}: UpdateEnumeratorProfilePayloadInterface): Promise<void> => {
  try {
    const userRef = doc(db, "users", id);

    await updateDoc(userRef, {
      ...enumerator,
      updatedAt: serverTimestamp(),
    });

  } catch (error) {
    console.error("Failed to update enumerator profile:", error);
    throw new Error("Failed to update profile. Please try again.");
  }
};

export const useUpdateEnumeratorProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateEnumeratorProfilePayloadInterface>({
    mutationFn: updateEnumeratorProfile,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.ENUMERATOR, variables.id],
      });
      notification.success({
        message: "Profile Updated",
        description: "Your profile has been successfully updated!",
      });
    },
    onError: (error: Error) => {
      notification.error({
        message: "Update Failed",
        description: error.message,
      });
    },
  });
};
